<template>
  <div>
    <div class="avatar bg-placeholder overflow-hidden" @click="$refs.avatar.click()">
      <img
        v-if="!user.avatar"
        alt="empty photo"
        class="text-neutralBackground2 object-cover"
        src="../../assets/images/placeholder.png"
      />
      <img
        v-else
        :src="user.avatar"
        alt="avatar"
        class="text-neutralBackground2 h-full w-full object-cover rounded-full"
      />
    </div>
    <input
      id="avatar"
      ref="avatar"
      accept="image/png, image/jpeg"
      class="hidden"
      name="avatar"
      type="file"
      @input="selectAvatar"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Avatar",
  computed: {
    ...mapState("auth", ["user"])
  },

  methods: {
    async selectAvatar(e) {
      const photo = new FormData();
      photo.append("avatar", e.target.files[0]);
      await this.$store.dispatch("auth/updateProfilePhoto", {
        photo,
        user: {
          expertise: this.user.expertise,
          language: this.user.languages.map((item) => item.id),
          area: this.user.area.map((item) => item.id)
        }
      });
      await this.$store.dispatch();
      this.$refs.avatar.value = "";
    }
  }
};
</script>

<style scoped>
.avatar {
  @apply cursor-pointer rounded-full border-4 h-32 w-32 mr-12 flex justify-center items-center;
  border-color: var(--primary-background);
  background-color: var(--neutral-background-3);
}

.bg-placeholder {
  background: #e4e3e1;
}
</style>
